<template>
    <Head title="Histórico de Votos" />
    <Authenticated>
        <Heading title="Histórico de Votos" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="component-background-desktop min-h-[70vh] px-6 py-12">
            
            <div class="flex items-start gap-x-4 mt-4">
                <FilterHistoric
                    :subregions="subregions"
                    @updateFilter="sendFilter($event)"
                />
                <div class="flex-col bg-white border border-gray-500 p-4 rounded-2xl w-full">
                    <div class="flex w-full justify-end">
                        <div class="flex gap-x-2">
                            <h1>Modo de visualização:</h1>
                            <div @click="miniatureMode = false" class="border border-gray-500 rounded text-xs bg-gray-200 cursor-pointer hover:bg-gray-300" :class="{'!bg-gray-300' : !miniatureMode}">
                                <Icon class="w-6 text-gray-500" name="GalleryCard"/>
                            </div>
                            <div @click="miniatureMode = true" class="border border-gray-500 rounded text-xs bg-gray-100 cursor-pointer hover:bg-gray-300" :class="{'!bg-gray-300' : miniatureMode}">
                                <Icon class="w-6 text-gray-500" name="GalleryCardMiniature"/>
                            </div>
                        </div>
                    </div>
                    <section
                    class="relative flex flex-wrap gap-x-2 gap-y-8 pt-4 min-h-[50vh] w-full"
                    >
                        <div v-if="computedGalleries.length == 0" class="absolute inset-0 flex justify-center items-center w-full h-full">
                            <p>Nenhuma execução encontrada.</p>
                        </div>
                        <loading
                            :active="isLoadingPage?.length > 0"
                            :is-full-page="false"
                            :z-index="10"
                        />
                        <ExecutionHistoricCard  
                            v-for="(item) in computedGalleries" 
                            :miniatureMode="miniatureMode"
                            :key="item.id" 
                            :gallery="item" 
                            :showInModal="showInModal"
                            @showParticipants="handleShowParticipantsModal($event)"
                        />
                        
                    </section>
                    <Pagination :limit="meta.limit" :total="meta.total" :startPage="meta.page" @page:selected="setPage($event)"/>
                </div>
            </div>
        </div>
        <transition v-if="showParticipantModal">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] px-4 py-4 relative"
                >
                    <button class="absolute top-2 right-2" @click="showParticipantModal = false">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Colaboradores da execução
                    </h1>
                    <ul class="uppercase">
                        <li v-for="(galleryParticipant, key) in participantsToShowInModal" :key="key">{{galleryParticipant.participant?.name}}</li>
                    </ul>
                </div>
            </div>
        </transition>
        <Gallery :gallery="currentGallery" />
    </Authenticated>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Pagination from "@/Components/UI/Pagination.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Gallery from "@/Components/Gallery.vue";
import ExecutionHistoricCard from "@/Components/ExecutionHistoricCard.vue";
import Carousel from "@/Components/CarouselSimple.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import ZipButton from "@/Components/Download/ZipButton.vue";
import FilterHistoric from "@/Components/PhotosVoting/FilterHistoric.vue";


export default {
    components: {
        Authenticated,
        Head,
        Heading,
        Head,
        Icon,
        Button,
        Gallery,
        Carousel,
        Pagination,
        Loading,
        ZipButton,
        ExecutionHistoricCard,
        FilterHistoric,
    },

    props: {
        contestId: String,
        galleriesResponse: Object,
        subregions: Object,
        weeklypassphrases: Object,
        total: Number,
    },

    data() {
        return {
            galleriesData: this.galleriesResponse.galleries,
            isFiltered: false,
            isLoading: false,
            isLoadingPage: [],
            currentGallery: "",
            filterData: {
                stage: 1
            },
            meta: {
                page: parseFloat(this.galleriesResponse.page),
                total: this.galleriesResponse.total,
                limit: this.galleriesResponse.limit,
            },
            showParticipantModal: false,
            participantsToShowInModal: [],
            miniatureMode: false,
        };
    },

    computed: {
        computedGalleries() {
            return this.galleriesData.map(gallery => {
                return {
                    ...gallery,
                    weeklypassphrase: this.getWeeklypassphrase(gallery.createdAt)
                }
            })
        },
    },

    methods: {
        async setPage(page) {
            this.meta.page = page;

            await this.fetchVotingHistoric({
                ...this.filterData,
                limit: this.limit,
                page: this.meta.page,
            });
        },
        sendFilter(data) {
            this.filterData = data;
            this.meta.page = 0;
            this.fetchVotingHistoric({...data, ...this.meta});
        },
        async fetchVotingHistoric(data) {
            const requestId = new Date().getTime();
            this.isLoadingPage = this.isLoadingPage.filter(
                (isLoadingObject) => isLoadingObject.requestId > requestId
            );
            this.isLoadingPage.push({
                requestId,
                loading: true,
            });

            try {
                await axios.get(route("photo-voting.historic-filter"), {
                    params: {
                        ...data,
                        contestId: this.contestId
                    }
                }).then((response) => {
                    const lastRequest = this.isLoadingPage.find(
                        (isLoadingObject) => isLoadingObject.requestId === requestId
                    );
                    if (lastRequest) {
                        this.isLoadingPage = [];
                        this.galleriesData = response?.data.galleries;
                        const responseTotal = response?.data.total;
                        if (responseTotal !== undefined && responseTotal >= 0) {
                            this.meta.total = responseTotal;
                        }

                        if (response.status == 200) {
                            this.isFiltered = true;
                        }
                    }
                });
                
            } catch(error) {
                console.log(error);
            }
        },
        clearFilter() {
            window.location = "/gallery";
        },
        showInModal(photos) {
            this.currentGallery = {
                exhibition: photos[0],
                photos: photos,
            };
        },
        getWeeklypassphrase(createdAt) {
            const getOnlyDate = function(date) {
                return moment(date).format('YYYY-MM-DD');
            };

            const createdDate = getOnlyDate(createdAt);

            const weeklypassphraseFiltered = this.weeklypassphrases.filter(el => getOnlyDate(el.startDate) <= createdDate && getOnlyDate(el.endDate) >= createdDate);
            const hasWeeklypassphrase = weeklypassphraseFiltered.length > 0;

            if(hasWeeklypassphrase) {
                return weeklypassphraseFiltered[0].passphrase;
            }

            return 'N/A';
        },
        handleShowParticipantsModal(participants) {
            this.participantsToShowInModal = participants;
            this.showParticipantModal = true;
        }
    },
};
</script>